import axios from "axios";

export const Device = {
    getDeviceId: async () => {
        let id = localStorage.getItem('_capuid');
        if (id){
            return id
        }
        id = generateUUID();
        localStorage.setItem('_capuid',id);
        return id;
    },
}